import { GET_BULKPIN_DOWNLOAD,SET_DISTRIBUTOR_PINS, GET_BULKPIN_EXCEL, INSERT_VOUCHER_MANAGEMENT, GET_VOUCHER_MANAGEMENT, UPDATE_VOUCHER_MANAGEMENT } from 'redux/admin-constants';

const initialState = {
  bulkPinData: [],
  bulkPinExcelData: [],
  setPinData:[],
  voucherManageData:[]
};

const reducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case GET_BULKPIN_DOWNLOAD: {
      return {
        ...state,
        bulkPinData: payload,
      };
    }
    case SET_DISTRIBUTOR_PINS: {
      return {
        ...state,
        setPinData: payload,
      };
    }

    case GET_BULKPIN_EXCEL: {
      return {
        ...state,
        bulkPinExcelData: payload,
      };
    }

        case GET_VOUCHER_MANAGEMENT: {
      return {
        ...state,
        voucherManageData: payload,
      };
    }

    case INSERT_VOUCHER_MANAGEMENT: {
      
      return {
        ...state,
        voucherManageData: [payload, ...state.voucherManageData],
      };
    }

      case UPDATE_VOUCHER_MANAGEMENT: {
        return {
          ...state, 
          voucherManageData:
           state.voucherManageData.map(item => item.vouchermanagementid === payload.vouchermanagementid ? 
            { ...item, ...payload} : item 
          )
        }
      }

    default:
      return state;
  }
};

export default reducer;